import { _t } from 'utils/translation';

const DASHBOARD = {
  CONTRACTS: {
    key: 'contracts',
    path: '/contracts',
    componentName: 'ContractsScreen',
    pathRegex: /^\/contracts$/,
    breadcrumb: () => [],
  },

  MONITORING: {
    key: 'monitoring',
    path: '/monitoring',
    componentName: 'Monitoring.MonitoringList',
    pathRegex: /^\/monitoring$/,
    title: 'Monitoring',
    breadcrumb: () => [],
  },

  MONITORING_SERVER: {
    key: 'monitoring-server',
    path: '/data-centers/:dcId/servers/:serverId/monitor',
    componentName: 'Monitoring.MonitoringServerGraphs',
    pathRegex: /^\/data-centers\/(.+)\/servers\/(.+)\/monitor$/,
    title: 'Monitor Server',
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'Server',
        onClick: (h) => {
          const { breadcrumbRegex, path } = DASHBOARD.SERVER;
          const [, dcId, serverId] = breadcrumbRegex.exec(window.location.pathname);
          h.push(path.replace(':dcId', dcId).replace(':id', serverId));
        },
      },
      {
        name: 'Monitoring',
        isCurrent: true,
      },
    ],
  },

  MONITORING_ALARMS: {
    key: 'monitoring-alarms',
    path: '/monitoring-alarms',
    componentName: 'Monitoring.MonitoringAlarmsList',
    pathRegex: /^\/monitoring-alarms$/,
    title: 'Monitoring Alarms',
    breadcrumb: () => [
      {
        name: 'Monitoring',
        route: DASHBOARD.MONITORING,
      },
      {
        name: 'Alarms',
        isCurrent: true,
      },
    ],
  },

  MONITORING_ALARM: {
    key: 'monitoring-alarm',
    path: '/monitoring-alarms/:id',
    componentName: 'Monitoring.MonitoringAlarmDetails',
    pathRegex: /^\/monitoring-alarms\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Monitoring',
        route: DASHBOARD.MONITORING,
      },
      {
        name: 'Alarms',
        route: DASHBOARD.MONITORING_ALARMS,
      },
      {
        name: 'Alarm',
        isCurrent: true,
      },
    ],
  },

  MONITORING_ACTIONS: {
    key: 'monitoring-actions',
    path: '/monitoring-actions',
    componentName: 'Monitoring.MonitoringActionsList',
    pathRegex: /^\/monitoring-actions$/,
    breadcrumb: () => [
      {
        name: 'Monitoring',
        route: DASHBOARD.MONITORING,
      },
      {
        name: 'Actions',
        isCurrent: true,
      },
    ],
  },

  MONITORING_ACTION: {
    key: 'monitoring-action',
    path: '/monitoring-actions/:id',
    componentName: 'Monitoring.MonitoringActionDetails',
    pathRegex: /^\/monitoring-actions\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Monitoring',
        route: DASHBOARD.MONITORING,
      },
      {
        name: 'Actions',
        route: DASHBOARD.MONITORING_ACTIONS,
      },
      {
        name: 'Action',
        isCurrent: true,
      },
    ],
  },

  STORAGE_IN_SERVER: {
    key: 'storageInServer',
    path: '/data-centers/:dcId/servers/:serverId/storages/:id/:type',
    title: 'Storage',
    componentName: 'StorageScreen',
    pathRegex: /^\/data-centers\/(.+)\/servers\/(.+)\/storages\/(.+?)\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'Server',
        onClick: (h) => {
          const { breadcrumbRegex, path } = DASHBOARD.SERVER;
          const [, dcId, serverId] = breadcrumbRegex.exec(window.location.pathname);
          h.push(path.replace(':dcId', dcId).replace(':id', serverId));
        },
      },
      {
        name: 'Storage',
        isCurrent: true,
      },
    ],
  },

  STORAGE: {
    key: 'storage',
    path: '/data-centers/:dcId/storages/:id',
    title: 'Storage',
    componentName: 'StorageScreen',
    pathRegex: /^\/data-centers\/(.+)\/storages\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'Storage',
        isCurrent: true,
      },
    ],
  },

  LAN: {
    key: 'lan',
    path: '/data-centers/:dcId/lans/:id',
    componentName: 'LanScreens.List',
    pathRegex: /^\/data-centers\/(.+)\/lans\/(.+)$/,
    title: 'LAN',
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'LAN',
        isCurrent: true,
      },
    ],
  },

  NIC: {
    key: 'nic',
    path: '/data-centers/:dcId/servers/:serverId/nics/:id',
    componentName: 'NICScreen',
    pathRegex: /^\/data-centers\/(.+)\/servers\/(.+)\/nics\/(.+)$/,
    title: 'NIC',
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'Server',
        onClick: (h) => {
          const { breadcrumbRegex, path } = DASHBOARD.SERVER;
          const [, dcId, serverId] = breadcrumbRegex.exec(window.location.pathname);
          h.push(path.replace(':dcId', dcId).replace(':id', serverId));
        },
      },
      {
        name: 'NIC',
        isCurrent: true,
      },
    ],
  },

  CREATE_SERVER: {
    key: 'createServer',
    path: '/data-centers/:dcId/servers/create',
    componentName: 'Shared.components.Servers.Create',
    pathRegex: /^\/data-centers\/(.+)\/servers\/create$/,
    breadcrumb: () => [],
  },

  SERVER: {
    key: 'server',
    path: '/data-centers/:dcId/servers/:id',
    title: _t('Server'),
    componentName: 'ServerScreen',
    pathRegex: /^\/data-centers\/(.+)\/servers\/(.+)$/,
    breadcrumbRegex: /^\/data-centers\/(.+?)\/servers\/(.+?)\//,
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'Server',
        isCurrent: true,
      },
    ],
  },

  LOAD_BALANCER: {
    key: 'loadBalancer',
    title: 'Load Balancer',
    path: '/data-centers/:dcId/load-balancers/:id',
    componentName: 'Loadbalancer',
    pathRegex: /^\/data-centers\/(.+)\/load-balancers\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'Load Balancer',
        isCurrent: true,
      },
    ],
  },

  NLB_FORWARDING_RULE: {
    key: 'nlbForwardingRule',
    path: '/data-centers/:dcId/networkloadbalancers/:nlbId/forwardingrules/:id',
    title: 'Forwarding Rule',
    componentName: 'NLB.NLBForwardingRule',
    pathRegex: /^\/data-centers\/(.+)\/networkloadbalancers\/(.+)\/forwardingrules\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'Network Loadbalancer',
        onClick: (h) => {
          const { breadcrumbRegex, path } = DASHBOARD.NETWORK_LOAD_BALANCER;
          const [, dcId, nlbId] = breadcrumbRegex.exec(window.location.pathname);
          h.push(path.replace(':dcId', dcId).replace(':id', nlbId));
        },
      },
      {
        name: 'Forwarding Rule',
        isCurrent: true,
      },
    ],
  },

  NETWORK_LOAD_BALANCER: {
    key: 'networkLoadBalancer',
    path: '/data-centers/:dcId/networkloadbalancers/:id',
    title: _t('Network Load Balancers'),
    componentName: 'NLB.NLBSingle',
    pathRegex: /^\/data-centers\/(.+)\/networkloadbalancers\/(.+)$/,
    breadcrumbRegex: /^\/data-centers\/(.+?)\/networkloadbalancers\/(.+?)\/.+$/,
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'NLB',
        isCurrent: true,
      },
    ],
  },

  ALB_FORWARDING_RULE: {
    key: 'albForwardingRule',
    path: '/data-centers/:dcId/application-load-balancer/:albId/forwarding-rules/:id',
    title: 'Forwarding Rule',
    componentName: 'ALB.SingleForwardingRule',
    pathRegex: /^\/data-centers\/(.+)\/application-load-balancer\/(.+)\/forwarding-rules\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'ALB',
        onClick: (h) => {
          const [, dcId, albId] = DASHBOARD.APPLICATION_LOAD_BALANCER.breadcrumbRegex.exec(window.location.pathname);
          h.push(DASHBOARD.APPLICATION_LOAD_BALANCER.path.replace(':dcId', dcId).replace(':id', albId));
        },
      },
      {
        name: 'Forwarding Rule',
        isCurrent: true,
      },
    ],
  },

  APPLICATION_LOAD_BALANCER: {
    key: 'alb',
    path: '/data-centers/:dcId/application-load-balancer/:id',
    title: 'Application Loadbalancers',
    componentName: 'ALB.Single',
    pathRegex: /^\/data-centers\/(.+)\/application-load-balancer\/(.+)$/,
    breadcrumbRegex: /^\/data-centers\/(.+?)\/application-load-balancer\/(.+?)\/.+$/,
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'Application Loadbalancer',
        isCurrent: true,
      },
    ],
  },

  NAT_GATEWAY: {
    key: 'natGateway',
    path: '/data-centers/:dcId/nat-gateways/:id',
    title: 'NAT Gateway',
    componentName: 'NatGateway',
    pathRegex: /^\/data-centers\/(.+)\/nat-gateways\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        route: DASHBOARD.DATA_CENTER,
      },
      {
        name: 'NAT Gateway',
        isCurrent: true,
      },
    ],
  },

  DATA_CENTERS: {
    key: 'dataCenters',
    path: '/data-centers',
    title: _t('Data Centers'),
    componentName: 'DataCentersScreen',
    pathRegex: /^\/data-centers$/,
    breadcrumb: () => [],
  },

  DATA_CENTER: {
    key: 'dataCenter',
    path: '/data-centers/:id',
    title: 'Data Center',
    componentName: 'DataCenterScreen',
    pathRegex: /^\/data-centers\/(.+)$/,
    breadcrumbRegex: /^\/data-centers\/(.+?)\//,
    breadcrumb: () => [
      {
        name: 'Home',
        route: DASHBOARD.DATA_CENTERS,
      },
      {
        name: 'Data Center',
        isCurrent: true,
      },
    ],
  },

  LANGUAGE: {
    key: 'language',
    path: '/language',
    componentName: 'LanguageScreen',
    pathRegex: /^\/language$/,
    breadcrumb: () => [],
  },

  SSH_KEYS: {
    key: 'sshKeys',
    path: '/ssh-keys',
    componentName: 'SSHKeysScreen',
    pathRegex: /^\/ssh-keys$/,
    breadcrumb: () => [],
  },

  IMAGES: {
    key: 'images',
    path: '/images',
    componentName: 'ImagesScreen',
    pathRegex: /^\/images$/,
    breadcrumb: () => [],
  },

  KUBERNETES: {
    key: 'kubernetes',
    path: '/kubernetes',
    componentName: 'Kubernetes.Clusters',
    pathRegex: /^\/kubernetes$/,
    breadcrumb: () => [],
  },

  KUBERNETES_NODEPOOL: {
    key: 'kubernetesNodepool',
    path: '/kubernetes/:cluster/nodepool/:nodepool',
    componentName: 'Kubernetes.Nodepool',
    pathRegex: /^\/kubernetes\/.+\/nodepool\/.+$/,
    breadcrumb: () => [
      {
        name: 'Kubernetes',
        route: DASHBOARD.KUBERNETES,
      },
      {
        name: 'Cluster',
        route: DASHBOARD.KUBERNETES_CLUSTER,
      },
      {
        name: 'Nodepool',
        isCurrent: true,
      },
    ],
  },

  KUBERNETES_CLUSTER: {
    key: 'kubernetesCluster',
    path: '/kubernetes/:id',
    componentName: 'Kubernetes.Cluster',
    pathRegex: /^\/kubernetes\/.+$/,
    breadcrumbRegex: /^\/kubernetes\/(.+)\/nodepool/,
    breadcrumb: () => [
      {
        name: 'Kubernetes',
        route: DASHBOARD.KUBERNETES,
      },
      {
        name: 'Cluster',
        isCurrent: true,
      },
    ],
  },

  USER_MANAGEMENT: {
    key: 'userManagement',
    path: '/user-management',
    componentName: 'UserManagementScreen',
    pathRegex: /^\/user-management$/,
    breadcrumb: () => [],
  },

  USER_MANAGEMENT_GROUPS: {
    key: 'userManagementType',
    path: '/user-management/groups',
    componentName: 'UserManagementScreen',
    pathRegex: /^\/user-management\/groups$/,
    // breadcrumb: () => [
    //   {
    //     name: 'User Management',
    //     route: DASHBOARD.USER_MANAGEMENT,
    //   },
    //   {
    //     name: 'Groups',
    //     isCurrent: true,
    //   },
    // ],
  },

  USER_MANAGEMENT_USERS: {
    key: 'userManagementType',
    path: '/user-management/users',
    componentName: 'UserManagementScreen',
    pathRegex: /^\/user-management\/users$/,
    // breadcrumb: () => [
    //   {
    //     name: 'User Management',
    //     route: DASHBOARD.USER_MANAGEMENT,
    //   },
    //   {
    //     name: 'Users',
    //     isCurrent: true,
    //   },
    // ],
  },

  USER_MANAGEMENT_GROUP: {
    key: 'userManagementGroup',
    path: '/user-management/group/:id',
    componentName: 'GroupSingleScreen',
    pathRegex: /^\/user-management\/group\/.+$/,
    breadcrumb: () => [
      // {
      //   name: 'User Management',
      //   route: DASHBOARD.USER_MANAGEMENT,
      // },
      {
        name: 'Groups',
        route: DASHBOARD.USER_MANAGEMENT_GROUPS,
      },
      {
        name: 'Group',
        isCurrent: true,
      },
    ],
  },

  USER_MANAGEMENT_USER: {
    key: 'userManagementUser',
    path: '/user-management/user/:id',
    componentName: 'UserSingleScreen',
    pathRegex: /^\/user-management\/user\/.+$/,
    breadcrumb: () => [
      // {
      //   name: 'User Management',
      //   route: DASHBOARD.USER_MANAGEMENT,
      // },
      {
        name: 'Users',
        route: DASHBOARD.USER_MANAGEMENT_USERS,
      },
      {
        name: 'User',
        isCurrent: true,
      },
    ],
  },

  GRPAH: {
    key: 'graph',
    path: '/graph',
    componentName: 'Graph',
    pathRegex: /^\/graph$/,
  },

  NOT_FOUND: {
    key: 'notFound',
    path: '/404',
    componentName: 'Shared.components.NotFound',
    pathRegex: /^\/404$/,
  },

  IPS: {
    key: 'ips',
    path: '/ips',
    componentName: 'IPs',
    pathRegex: /^\/ips$/,
  },

  BACKUP_UNIT: {
    key: 'backupunit',
    path: '/backup-units',
    componentName: 'BackupUnits',
    pathRegex: /^\/backup-units$/,
  },

  INVOICES: {
    key: 'invoices',
    path: '/invoices',
    componentName: 'Invoice.InvoiceList',
    title: _t('Invoices'),
    pathRegex: /^\/invoices$/,
    breadcrumb: () => [],
  },

  INVOICE_CURRENT: {
    key: 'invoiceCurrent',
    path: '/invoices/current-invoice',
    componentName: 'Invoice.InvoiceCurrent',
    title: _t('Invoice'),
    pathRegex: /^\/invoices\/current-invoice$/,
    breadcrumb: () => [
      {
        name: 'Invoices',
        route: DASHBOARD.INVOICES,
      },
      {
        name: 'Current Invoice',
        isCurrent: true,
      },
    ],
  },

  INVOICE_CURRENT_DATA_CENTER: {
    key: 'invoiceCurrentDataCenter',
    path: '/invoices/current-invoice/:datacenterId',
    componentName: 'Invoice.InvoiceCurrentDataCenter',
    pathRegex: /^\/invoices\/current-invoice\/(.+?)$/,
    title: _t('Data Center'),
    breadcrumb: () => [
      {
        name: 'Invoices',
        route: DASHBOARD.INVOICES,
      },
      {
        name: 'Current Invoice',
        route: DASHBOARD.INVOICE_CURRENT,
      },
      {
        name: 'Usage',
        isCurrent: true,
      },
    ],
  },

  INVOICE_DATA_CENTER: {
    key: 'invoiceDataCenter',
    path: '/invoices/:id/:datacenterId',
    componentName: 'Invoice.InvoiceDataCenter',
    title: _t('Data Center'),
    pathRegex: /^\/invoices\/(.+?)\/(.+?)$/,
    breadcrumb: () => [
      {
        name: 'Invoices',
        route: DASHBOARD.INVOICES,
      },
      {
        name: 'Invoice',
        route: DASHBOARD.INVOICE,
      },
      {
        name: 'Usage',
        isCurrent: true,
      },
    ],
  },

  INVOICE: {
    key: 'invoice',
    path: '/invoices/:id',
    componentName: 'Invoice.InvoiceSingle',
    title: _t('Invoice'),
    pathRegex: /^\/invoices\/.+$/,
    breadcrumbRegex: /\/invoices\/(.+)\//,
    breadcrumb: () => [
      {
        name: 'Invoices',
        route: DASHBOARD.INVOICES,
      },
      {
        name: 'Invoice',
        isCurrent: true,
      },
    ],
  },

  AUTO_SCALING: {
    key: 'autoScaling',
    path: '/auto-scaling',
    title: 'Auto Scaling',
    componentName: 'AutoScaling.List',
    pathRegex: /^\/auto-scaling$/,
    breadcrumb: () => [],
  },

  AUTO_SCALING_GROUP: {
    key: 'autoScalingGroup',
    path: '/auto-scaling/group/:id',
    title: 'Autoscaling Group',
    componentName: 'AutoScaling.Group.Single',
    pathRegex: /^\/auto-scaling\/group\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Groups',
        route: DASHBOARD.AUTO_SCALING,
      },
      {
        name: 'Group',
        isCurrent: true,
      },
    ],
  },

  TARGET_GROUPS: {
    key: 'targetGroups',
    path: '/target-groups',
    title: 'Target Groups',
    componentName: 'TargetGroups.List',
    pathRegex: /^\/target-groups$/,
    breadcrumb: () => [],
  },

  TARGET_GROUPS_CREATE: {
    key: 'targetGroupsCreate',
    path: '/target-groups/create/:id',
    componentName: 'TargetGroups.Create',
    pathRegex: /^\/target-groups\/create\/.+$/,
    breadcrumb: () => [
      {
        name: 'Target Groups',
        route: DASHBOARD.TARGET_GROUPS,
      },
      {
        name: 'Create',
        isCurrent: true,
      },
    ],
  },

  TARGET_GROUP: {
    key: 'targetGroups',
    path: '/target-groups/:id',
    title: 'Target Group',
    componentName: 'TargetGroups.Single',
    pathRegex: /^\/target-groups\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Target Groups',
        route: DASHBOARD.TARGET_GROUPS,
      },
      {
        name: 'Details',
        isCurrent: true,
      },
    ],
  },

  CERTIFICATE_MANAGER: {
    key: 'certificate-manager',
    path: '/certificate-manager',
    componentName: 'CertificateManager',
    pathRegex: /^\/certificate-manager$/,
    title: 'Certificate Manager',
    icon: 'shield-alt',
  },

  DATABASES: {
    key: 'dbaas',
    path: '/dbaas',
    title: _t('DATABASES.Databases'),
    componentName: 'Databases.List',
    pathRegex: /\/dbaas$/,
    breadcrumb: () => [],
  },

  DATABASE_MONITORING: {
    key: 'databaseMonitoring',
    path: '/dbaas/postgresql/:id/monitoring',
    title: 'Database Monitoring',
    componentName: 'Databases.Monitoring',
    pathRegex: /^\/dbaas\/postgresql\/(.+?)\/monitoring$/,
    breadcrumb: () => [
      {
        name: _t('DATABASES.BREADCRUMBS.DATABASES'),
        route: DASHBOARD.DATABASES,
      },
      {
        name: _t('DATABASES.BREADCRUMBS.DATABASE'),
        route: DASHBOARD.DBAAS_POSTGRESQL,
      },
      {
        name: _t('DATABASES.BREADCRUMBS.MONITORING'),
        isCurrent: true,
      },
    ],
  },

  DBAAS_POSTGRESQL: {
    key: 'postgresql',
    path: '/dbaas/postgresql/:id',
    componentName: 'Databases.postgresql.Single',
    breadcrumbRegex: /^\/dbaas\/postgresql\/(.+?)\//,
    pathRegex: /^\/dbaas\/postgresql\/(.+)/,
    breadcrumb: () => [
      {
        name: _t('DATABASES.BREADCRUMBS.DATABASES'),
        route: DASHBOARD.DATABASES,
      },
      {
        name: _t('DATABASES.BREADCRUMBS.POSTGRESQL'),
        isCurrent: true,
      },
    ],
  },
  DBAAS_MONGODB: {
    key: 'mongodb',
    path: '/dbaas/mongodb/:id',
    componentName: 'Databases.mongodb.Single',
    breadcrumbRegex: /^\/dbaas\/mongodb\/(.+?)\//,
    pathRegex: /^\/dbaas\/mongodb\/(.+)/,
    breadcrumb: () => [
      {
        name: _t('DATABASES.BREADCRUMBS.DATABASES'),
        route: DASHBOARD.DATABASES,
      },
      {
        name: _t('DATABASES.BREADCRUMBS.MONGODB'),
        isCurrent: true,
      },
    ],
  },

  // Container Registry

  CONTAINER_REGISTRY_REPOSITORY: {
    key: 'containerRegistryRepository',
    path: '/container-registry/list/:id/repo/:repoName+',
    title: 'Repository',
    componentName: 'ContainerRegistry.Registry.Repository',
    pathRegex: /^\/container-registry\/list\/(.+)\/repo\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Container Registries',
        route: DASHBOARD.CONTAINER_REGISTRY_LIST,
      },
      {
        name: 'Registry',
        route: DASHBOARD.CONTAINER_REGISTRY_SINGLE,
        onClick: (h) => {
          const [, id] = DASHBOARD.CONTAINER_REGISTRY_REPOSITORY.pathRegex.exec(window.location.pathname);
          h.push(DASHBOARD.CONTAINER_REGISTRY_SINGLE.path.replace(':id', id));
        },
      },
      {
        name: 'Repository',
        isCurrent: true,
      },
    ],
  },

  CONTAINER_REGISTRY_SINGLE: {
    key: 'containerRegistrySingle',
    path: '/container-registry/list/:id',
    title: 'Container Registry',
    componentName: 'ContainerRegistry.Registry.Single',
    pathRegex: /^\/container-registry\/list\/(.+)$/,
    breadcrumb: () => [
      {
        name: 'Container Registries',
        route: DASHBOARD.CONTAINER_REGISTRY_LIST,
      },
      {
        name: 'Registry',
        isCurrent: true,
      },
    ],
  },

  CONTAINER_REGISTRY_LIST: {
    key: 'containerRegistryList',
    path: '/container-registry/list',
    title: 'Container Registry',
    componentName: 'ContainerRegistry.Registry.List',
    pathRegex: /^\/container-registry\/list$/,
  },

  SAMPLE: {
    key: 'sample',
    title: 'Sample Title',
    path: '/sample',
    componentName: 'Sample',
    pathRegex: /\/sample$/,
  },
};

const NON_SECURE = {
  LOGIN: {
    key: 'login',
    path: '/login',
    componentName: 'LoginScreen',
    pathRegex: /^\/login$/,
  },

  DCD_LOGIN_ERROR: {
    key: 'dcdLoginError',
    path: '/dcd-login-error',
    componentName: 'DcdLoginError',
    pathRegex: /^\/dcd-login-error$/,
  },

  CONFIGURATION: {
    key: 'configuration',
    title: 'Configurations',
    path: '/config',
    componentName: 'Configuration',
    pathRegex: /\/config$/,
  },
};

export const ROUTE = {
  DASHBOARD,
  NON_SECURE,
};
